export default __webpack_public_path__ + "e2bc1b30f73b784b68e0f2345354df9f.png";